module.exports = __webpack_public_path__ + "img/DE00537.8323fec4.png";